export default __webpack_public_path__ + "static/media/AI_ico.2ba05fe1.svg";